import BaseEntity from '@/editor/entities/BaseEntity';
import { globalStores } from '@/editor/stores';
import { EEntityType, ESceneMode } from '@/editor/types';

export class BaseManager<BaseData extends { id: string }> {
  private _EntityClass: new (data: BaseData) => BaseEntity<EEntityType>;
  private _list: BaseEntity<EEntityType>[] = [];
  private _prevMode: ESceneMode = globalStores.sceneMode;

  constructor(EntityClass: new (data: BaseData) => BaseEntity<EEntityType>) {
    this._EntityClass = EntityClass;
  }

  private addEntity(data: BaseData) {
    const entity = new this._EntityClass(data);
    this._list.push(entity);
  }

  getEntityById(id: string) {
    return this._list.find((entity) => entity.id === id);
  }

  private delEntityById(id: string) {
    const index = this._list.findIndex((entity) => entity.id === id);
    if (index !== -1) this.delEntityByIndex(index);
  }

  private delEntityByIndex(index: number) {
    const entity = this._list[index];
    if (!entity) return;

    entity.dispose();
    this._list.splice(index, 1);
  }

  update(datas: BaseData[], forceUpdate = false) {
    const ids = datas.map((d) => d.id);

    for (let i = this._list.length - 1; i >= 0; i--) {
      const entity = this._list[i];
      if (!ids.includes(entity.id)) {
        this.delEntityByIndex(i);
      }
    }

    for (let i = 0; i < datas.length; i++) {
      const data = datas[i];
      const entity = this.getEntityById(data.id);
      if (!entity) {
        this.addEntity(data);
      } else {
        entity.update({ ...data, forceUpdate });
      }
    }
  }
}
